import { render, staticRenderFns } from "./PurchaseOrderItem.vue?vue&type=template&id=13dbd7d7&"
import script from "./PurchaseOrderItem.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderItem.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports